import dayjs from 'dayjs';
import { Receipt } from 'lucide-react';
import { useNavigate } from 'react-router';

import type { ReceiptBaseDto } from '@/api/types';
import { Badge } from '@/components/ui/badge.tsx';
import ReceiptStatus from '@/features/receipts/receipt-status/receipt-status.tsx';
import { formatPrice } from '@/helpers/formatters.ts';

type ReceiptRowProps = {
  receipt: ReceiptBaseDto;
};

const ReceiptRow = ({ receipt }: ReceiptRowProps) => {
  const navigate = useNavigate();

  return (
    <div
      className="flex items-center justify-between p-4 border rounded-lg hover:bg-muted/50 transition-colors text-xs font-normal cursor-pointer"
      onClick={() => navigate(receipt.uuid)}
    >
      <div className="flex items-center gap-4">
        <div className="w-10 h-10 bg-muted rounded-full flex items-center justify-center">
          <Receipt className="w-5 h-5 text-muted-foreground" />
        </div>
        <div className="flex flex-col gap-1">
          <div className="flex gap-2">
            <span className="font-medium text-sm">{receipt.party}</span>
            <ReceiptStatus status={receipt.status} />
            {receipt.assignedTransfer && <Badge variant="success">Assigned</Badge>}
          </div>
          <span className="text-muted-foreground empty:hidden">
            {receipt.date && dayjs(receipt.date).format('DD.MM.YYYY HH:mm')}
          </span>
          <span className="text-muted-foreground empty:hidden">
            {!receipt.party && receipt.extId}
          </span>
        </div>
      </div>
      <div className="flex flex-col text-right">
        <span className="font-semibold text-lg">{formatPrice(receipt.amount)}</span>
        <span className="text-muted-foreground empty:hidden">
          {!!receipt.totalItems && <span>{receipt.totalItems} items</span>}
        </span>
      </div>
    </div>
  );
};

export default ReceiptRow;
